import styled from 'styled-components';

export const Cell = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${(props) => {
    switch (props.type) {
      case 'today':
        return '#dee4e9';
      case 'week':
        return '#fafafa';
      case 'selected':
        return '#90b9d6';
      default:
        return 'none';
    }
  }}
`;

export const WeekDay = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, .5);
  font-size: 11px;
`;

export const MonthDay = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, .7);
  font-size: 12px;
  font-weight: bold;
`;
